import React, { Component } from "react";
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <div className="logo"></div>
                <a href="https://ynet.co.il/" target="_blank"><div className="ynet"></div></a>
              </div>
              <div className="welcome">
                <div className="head">
                  <div className="icon"></div>
                  <div className="title">
                    <div className="desc">
                      יוזמים עתיד מבטיח
                    </div>
                    <div className="teaser">
                      הבחירה בידיים שלכם
                    </div>
                  </div>
                </div>
              </div>
              <div className="motd">
                תחרות היזמות הארצית של קבוצת עמל, ע"ש מר שמעון פרס ז"ל הנשיא התשיעי של מדינת ישראל, יצאה לדרך עם עשרות מיזמים, ועתה, שמונה מהם הגיעו לגמר הגדול שייערך ב-16.9.19 במרכז פרס לשלום ולחדשנות, בשיתוף עם חברת התעופה אל על. <br />רגע לפני, אנחנו מזמינים אתכם לבחור במיזם שיזכה בתואר "חביב הקהל".<br /> בחרו את המיזם שלכם מתוך השמונה<br className="mob" /> המוצגים כאן והשפיעו!
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx